import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { X } from 'lucide-react';

export interface FlowHeaderProps {
  flowTitle: string;
  startTime: string;
  onClose?: () => void;
  className?: string;
}

export function FlowHeader({
  flowTitle,
  startTime,
  onClose,
  className,
}: FlowHeaderProps) {
  return (
    <div
      className={
        className ??
        'flex w-full items-center justify-between border-b border-zinc-700 p-4'
      }
    >
      <div className="flex items-end gap-2">
        <Heading styleAs="h3" className="whitespace-nowrap text-white">
          {flowTitle}
        </Heading>
        <span className="text-base leading-6 font-bold text-zinc-400">
          FLOW
        </span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-base leading-6 font-normal text-zinc-400">
          Flow started {startTime}
        </span>
        {onClose && (
          <Button
            variant="outline"
            size="icon"
            onClick={onClose}
            className="h-10 w-10 shrink-0 rounded-md bg-zinc-800"
          >
            <X className="size-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
